import {Component, inject, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
  ModalCadastroVisualizacaoOperadorComponent
} from './modal-cadastro-visualizacao-operador/modal-cadastro-visualizacao-operador.component';
import {UsuarioService} from '../shared/service/usuario.service';
import {MsgService} from '../shared/service/msg.service';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {DatePipe} from '@angular/common';
import {CpfCnpjMaskPipe} from '../shared/pipe/cpf-cnpj-mask.pipe';
import {CelularMaskPipe} from '../shared/pipe/celular-mask.pipe';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthService} from '../shared/service/auth.service';
import { Usuario } from '../shared/model/usuario/usuario.model';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import { TabelaSkeletonComponent } from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { debounceTime } from 'rxjs';
import { FiltrosUsuarioModel } from '../shared/model/usuario/filtros-usuario.model';
import {MatIconModule} from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';

@Component({
  selector: 'app-operador',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    MatTableModule,
    DatePipe,
    CpfCnpjMaskPipe,
    CelularMaskPipe,
    FormFieldComponent,
    TabelaSkeletonComponent,
    MatIconModule,
    ReactiveFormsModule,
    MatTooltipModule
  ],
  templateUrl: './operador.component.html',
  styleUrl: './operador.component.css'
})
export class OperadorComponent implements OnInit {
  operadores: Usuario[] = [];
  operadoresFiltered: Usuario[] = [];
  operadoresDataSource = new MatTableDataSource<Usuario>();

  displayedColumns: string[] = ['acao', 'foto', 'nome', 'telefone', 'email', 'cpf', 'setor', 'usuarioCriacao', 'dataCriacao', 'dataAlteracao', 'canais', 'ativo'];

  carregandoOperadores = false;
  operadoresCarregados = false;

  formOperador!: FormGroup;
  filtros: FiltrosUsuarioModel = new FiltrosUsuarioModel()

  private readonly usuarioService = inject(UsuarioService);
  private readonly dialog = inject(MatDialog);
  private readonly msgService = inject(MsgService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);
  private readonly fb = inject(FormBuilder);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.formOperador = this.fb.group({ nomeUsuario: [''] });
    this.buscarOperadores();
    this.configurarDebounce();
  }

  buscarOperadores() {
    this.carregandoOperadores = true
    this.usuarioService.buscarOperadoresPorGrupoComFiltro(this.filtros).subscribe({
      next: res => {
        this.operadoresCarregados = false;
        this.operadores = res.content || [];
        this.operadoresFiltered = this.operadores;
        this.operadoresDataSource = new MatTableDataSource(this.operadores);
      },
      complete: () => {
        this.carregandoOperadores = false;
        this.operadoresCarregados = true;
      }
    });
  }

  configurarDebounce(): void {
    this.formOperador.get('nomeUsuario')!.valueChanges.pipe(debounceTime(300)).subscribe({
      next: value => this.filtrarPorNome(value)
    });
  }

  filtrarPorNome(nome: string): void {
    this.filtros.nome = nome;
    this.buscarOperadores();
  }

  abrirModal(visualizar: boolean, operador?: Usuario) {
    const operadorEnvio = new Usuario(operador?.id, operador?.nome, operador?.cpf, operador?.telefone, operador?.email, operador?.cargo, operador?.usuarioAd, operador?.perfis, operador?.prefixoGrupo, operador?.grupo, operador?.login, operador?.ativo, operador?.perfil, operador?.ldapHabilitado, operador?.urlImg, operador?.imgBase64, operador?.extensaoImg, operador?.uuid, operador?.canais, operador?.setorDTO);
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoOperadorComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, operador: operadorEnvio },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) {
          dialogRef.close();
        }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.usuarioService.salvarOperador(res).subscribe({
            next: () => {
              this.msgService.msgSucesso('Sucesso ao salvar operador!');
              this.buscarOperadores();
            }
          });
        }
      }
    });
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }
}
